import React from 'react';
import { Divider, AppBar, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Info as InfoIcon } from 'react-feather';
import { JupiterTheme, CloseButton } from '@jupiterone/jupiter-web-toolkit';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    appBar: {
      background: theme.palette.background.dark,
      padding: theme.spacing(2),
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
    },
    header: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.coolGrey[500],
      letterSpacing: 1.6,
      textTransform: 'uppercase',
    },
    infoIcon: {
      cursor: 'default !important',
      marginRight: theme.spacing(1),
      '&:hover': {
        color: `${theme.palette.coolGrey[500]} !important`,
      },
    },
    closeButton: {
      position: 'absolute',
      right: 0,
    },
  })
);

type DrawerAppBarProps = {
  handleClose: () => void;
};
const DrawerAppBar = ({ handleClose }: DrawerAppBarProps) => {
  const classes = useStyles();

  return (
    <>
      <Divider />
      <AppBar position="static" className={classes.appBar}>
        <Typography className={classes.header}>
          <InfoIcon className={classes.infoIcon} />
          Notifications
        </Typography>
        <CloseButton onClose={handleClose} className={classes.closeButton} />
      </AppBar>
      <Divider />
    </>
  );
};

export default DrawerAppBar;
